import { render, staticRenderFns } from "./circular-echarts.vue?vue&type=template&id=dcfe2a98&scoped=true&"
import script from "./circular-echarts.vue?vue&type=script&lang=ts&"
export * from "./circular-echarts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcfe2a98",
  null
  
)

export default component.exports